import React from 'react'
import { Link } from 'gatsby'

// Failed Component
export function FormFailed() {
    return (
        <div className="container">
            <div className="row justify-content-center align-items-center mt-5">
                <div className="col-12 col-xl-10 failed">
                    <div
                        style={{ maxWidth: '600px' }}
                        className="mx-auto text-center"
                    >
                        {/* Failed Title */}
                        <h3 className="failed-title mb-3 milan-text-red text-center">
                            Oops! Something went wrong
                        </h3>

                        {/* Failed Subtitle */}
                        <h6 className="failed-subtitle mb-4 text-center">
                            We couldn't process your request
                        </h6>

                        {/* Info Card with Contact Link */}
                        <div className="info-card alert alert-danger">
                            <p className="mb-0 text-center">
                                Click{' '}
                                <Link
                                    to="/company/contact-us/"
                                    className="milan-text-primary text-decoration-underline"
                                >
                                    here
                                </Link>{' '}
                                to contact us.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
